import OrderFulfillmentService from "@/services/order.fulfillment";
import notification from "@/services/notification";

export default {
  namespaced: true,
  state: {
    loading_branches: false,
    brands_branches: [],
    stored_brands_branches: [],
    brand_branches_max_page: null,
    loading: false,
    saving: false,
    errors: null,
    delivery_tab_settings: null,
    pickup_tab_settings: null,
    pre_order_schedule: null,
    fulfillment_fees: null,
    fulfillment_settings: null,
    saveFulfillmentFeesMsg: ''
  },
  getters: {
    loading_branches: state => state.loading_branches,
    brands_branches: state => state.brands_branches,
    stored_brands_branches: state => state.stored_brands_branches,
    brand_branches_max_page: state => state.brand_branches_max_page,
    loading: state => state.loading,
    saving: state => state.saving,
    errors: state => state.errors,
    delivery_tab_settings: state => state.delivery_tab_settings,
    pickup_tab_settings: state => state.pickup_tab_settings,
    pre_order_schedule: state => state.pre_order_schedule,
    fulfillment_fees: state => state.fulfillment_fees,
    fulfillment_settings: state => state.fulfillment_settings,
    saveFulfillmentFeesMsg: state => state.saveFulfillmentFeesMsg
  },
  mutations: {
    set_loading_branches(state, status) {
      state.loading_branches = status;
    },
    set_brands_branches(state, data) {
      if (data.reset) state.brands_branches = []; // reset brands_branches array

      const brands_uuid = state.brands_branches.map(brand => brand.uuid);
      data.items.map(brand => {
        if (!brands_uuid.includes(brand.uuid) && brand.branches.length > 0) state.brands_branches.push(brand);
      });
    },
    set_stored_brands_branches(state, items) {
      const brands_uuid = state.stored_brands_branches.map(brand => brand.uuid);
      items.map(brand => {
        if (!brands_uuid.includes(brand.uuid) && brand.branches.length > 0) state.stored_brands_branches.push(brand);
      });
    },
    set_brand_branches_max_page(state, max) {
      state.brand_branches_max_page = max;
    },
    set_loading(state, value) {
      state.loading = value;
    },
    set_saving(state, value) {
      state.saving = value;
    },
    set_errors(state, errors) {
      state.errors = errors;
    },
    set_delivery_tab_settings(state, settings) {
      state.delivery_tab_settings = settings;
    },
    set_pickup_tab_settings(state, settings) {
      state.pickup_tab_settings = settings;
    },
    set_pre_order_schedule(state, pre_order_schedule) {
      state.pre_order_schedule = pre_order_schedule;
    },
    set_fulfillment_fees(state, settings) {
      state.fulfillment_fees = settings;
    },
    set_fulfillment_settings(state, fulfillment_settings) {
      state.fulfillment_settings = fulfillment_settings;
    },
    set_save_fulfillment_msg(state, msg) {
      state.saveFulfillmentFeesMsg = msg;
    },
    reset_brands_branches(state) {
      state.brands_branches = [];
    }
  },
  actions: {
    async getBrandsBranches({ commit }, payload) {
      if (payload.reset) {
        commit('set_loading_branches', true);
        commit('reset_brands_branches');
      }
      try {
        const response = await OrderFulfillmentService.getBrandsBranches(payload.param);
        commit('set_stored_brands_branches', response.data);
        commit('set_brands_branches', {
          items: response.data,
          reset: payload.reset
        });
        commit('set_brand_branches_max_page', response.max_page);
      } catch (errors) {
        commit('set_errors', errors);
      } finally {
        commit('set_loading_branches', false);
      }
    },
    async getDeliverySettings({ commit }) {
      commit('set_loading', true);
      try {
        const { settings } = await OrderFulfillmentService.getDeliverySettings();
        commit('set_delivery_tab_settings', settings);
      } catch (errors) {
        commit('set_errors', errors);
      } finally {
        commit('set_loading', false);
      }
    },
    async saveDeliverySettings({ commit }, payload) {
      commit('set_saving', true);
      commit('set_errors', null);
      try {
        const { message } = await OrderFulfillmentService.saveDeliverySettings(payload);
        notification.success(message);
      } catch ({ errors }) {
        for (const [key, error] of Object.entries(errors)) {
          errors[key] = error.split(".").join(" ");
        }
        commit('set_errors', errors);
      } finally {
        commit('set_saving', false);
      }
    },

    async getPickupSettings({ commit }) {
      commit('set_loading', true);
      try {
        const { settings } = await OrderFulfillmentService.getPickupSettings();
        commit('set_pickup_tab_settings', settings);
      } catch (errors) {
        commit('set_errors', errors);
      } finally {
        commit('set_loading', false);
      }
    },
    async savePickupSettings({ commit }, payload) {
      commit('set_saving', true);
      commit('set_errors', null);
      try {
        const { message } = await OrderFulfillmentService.savePickupSettings(payload);
        notification.success(message);
      } catch ({ errors }) {
        for (const [key, error] of Object.entries(errors)) {
          errors[key] = error.split(".").join(" ");
        }
        commit('set_errors', errors);
      } finally {
        commit('set_saving', false);
      }
    },
    async getPreOrderingSchedule({ commit }, payload) {
      commit('set_loading', true);
      try {
        const { data } = await OrderFulfillmentService.getPreOrderingSchedule(payload);
        commit('set_pre_order_schedule', data);
      } catch (errors) {
        commit('set_errors', errors);
      } finally {
        commit('set_loading', false);
      }
    },
    async savePreOrderingSchedule({ commit }, payload) {
      commit('set_saving', true);
      try {
        const { message } = await OrderFulfillmentService.savePreOrderingSchedule(payload);
        notification.success(message);
      } catch ({ errors }) {
        commit('set_errors', errors);
      } finally {
        commit('set_saving', false);
      }
    },
    async getFulfillmentFeesSettings({ commit }, param) {
      commit('set_loading', true);
      try {
        const { data } = await OrderFulfillmentService.getFulfillmentFeesSettings(param);
        commit('set_fulfillment_fees', data);
      } catch (errors) {
        commit('set_errors', errors);
      } finally {
        commit('set_loading', false);
      }
    },
    async saveFulfillmentFeesSettings({ commit }, payload) {
      commit('set_saving', true);
      try {
        const { message } = await OrderFulfillmentService.saveFulfillmentFeesSettings(payload);
        commit('set_save_fulfillment_msg', message);
      } catch ({ errors }) {
        commit('set_errors', errors);
      } finally {
        commit('set_saving', false);
      }
    },
    async getFulfillmentSettings({ commit }) {
      commit('set_loading', true);
      try {
        const { data } = await OrderFulfillmentService.getFulfillmentSettings();
        commit('set_fulfillment_settings', data);
      } catch ({ errors }) {
        commit('set_errors', errors);
      } finally {
        commit('set_loading', false);
      }
    },
    async saveFulfillmentSettings({ commit }, payload) {
      commit('set_saving', true);
      try {
        const { message } = await OrderFulfillmentService.saveFulfillmentSettings(payload);
        notification.success(message);
      } catch ({ errors }) {
        commit('set_errors', errors);
      } finally {
        commit('set_saving', false);
      }
    },
    async saveDineInFeeSettings({ commit, state }, payload) {
      commit('set_saving', true);
      try {
        const { message } = await OrderFulfillmentService.saveDineInFeeSettings(payload);
        if(message.toLowerCase().includes('no settings found')) {
          commit('set_errors', {
            enable_dine_in_service_fee: message
          });
        } else if(!state.saveFulfillmentFeesMsg) {
          commit('set_save_fulfillment_msg', message);
        }
      } catch ({ errors }) {
        commit('set_errors', errors);
      } finally {
        commit('set_saving', false);
      }
    }
  }
}